<template>
  <div class="container-fluid">
    <page-header
      class="mt-4 mt-md-0 mt-sm-4"
      left-side-class="col-xl-10"
      right-side-class="col-xl-2 text-right"
      :page="headerConfig"
    >
      <template v-slot:customActions>
        <ActionButton
          id="go-back-btn"
          text="Regresar"
          i="fas fa-arrow-circle-left"
          variant="ab-btn  ab-btn-outline-success m-1"
          @click="$router.go(-1)"
        />

        <ActionButton
          id="add-schedule-item-btn"
          text="Guardar"
          i="fas fa-save"
          variant="success m-1"
          @click="handleSaveItem"
        />
      </template>
    </page-header>

    <ValidationObserver ref="publishInformation" novalidate>
      <information-to-publish
        v-model="item.informationToPublish"
        :areaOptions="options.area"
        :typeOptions="options.type"
        :categoryOptions="options.category"
      />
      <documents-section
        v-model="item.documents"
        :main-image-file="item.mainImageFile"
        :thumbnail-image-file="item.thumbnailImageFile"
      />
    </ValidationObserver>

    <tags-section v-model="item.tags" :options="options.tag" />

    <ValidationObserver ref="workshopInfoRef" novalidate>
      <div v-if="showWorkshopDetailSection">
        <icon-view
          class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
          icon="fas fa-calendar-edit color-orange mb-1"
          title="Detalle del Taller o Evento"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
          :gradient="true"
        />

        <div class="row my-3">
          <div class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required' : ''"
            >
              <custom-date-picker
                :error="errors[0]"
                id="dp-start"
                classContainer="w-100"
                placeholder="DD/MM/YYYY"
                label="Fecha de Comienzo:"
                v-model="item.workshopDetail.startDate"
                custom-error-msg="Favor seleccionar fecha de comienzo"
              />
            </validation-provider>
          </div>

          <div class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required' : ''"
            >
              <custom-time-picker
                :error="errors[0]"
                id="tp-start"
                classContainer="w-100"
                label="Hora de Comienzo:"
                placeholder="00:00:00 AM"
                v-model="item.workshopDetail.startTime"
                custom-error-msg="Favor seleccionar hora de comienzo"
              />
            </validation-provider>
          </div>

          <div class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required' : ''"
            >
              <custom-date-picker
                :error="errors[0]"
                id="dp-end"
                classContainer="w-100"
                placeholder="DD/MM/YYYY"
                label="Fecha de Finalización:"
                v-model="item.workshopDetail.endDate"
                :min-date="item.workshopDetail.startDate"
                custom-error-msg="Favor seleccionar fecha de finalización:"
              />
            </validation-provider>
          </div>

          <div class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required' : ''"
            >
              <custom-time-picker
                :error="errors[0]"
                id="tp-end"
                classContainer="w-100"
                placeholder="00:00:00 AM"
                label="Hora de Finalización:"
                v-model="item.workshopDetail.endTime"
                custom-error-msg="Favor seleccionar hora de finalización"
              />
            </validation-provider>
          </div>
        </div>

        <div class="row my-3">
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="input-price"
                label="Costo:"
                type="number"
                maxlength="30"
                v-model="item.workshopDetail.cost"
                :error="errors[0]"
                custom-error-msg="El costo es requerido."
              >
              </custom-input>
            </validation-provider>
          </div>

          <div class="col-md-9">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                id="input-registry"
                label="Registro:"
                v-model="item.workshopDetail.registrationText"
                maxlength="30"
                :error="errors[0]"
                custom-error-msg="El registro es requerido."
              >
              </custom-input>
            </validation-provider>
          </div>
        </div>

        <validation-provider
          v-slot="{ errors }"
          :rules="{
            regex: urlRegexRule,
            required: !!showWorkshopDetailSection
          }"
        >
          <custom-input
            id="input-registry-url"
            label="Insertar URL para publicar el enlace para el registro en línea (debe comenzar con https://):"
            maxlength="150"
            v-model="item.workshopDetail.registrationUrl"
            :error="errors[0]"
            custom-error-msg="La URL no es válida."
          >
          </custom-input>
        </validation-provider>
      </div>
    </ValidationObserver>
    <div class="row my-3" v-if="showWorkshopDetailSection">
      <div class="col-md-12">
        <regions-section
          v-model="item.workshopDetail.regions"
          :options="options.region"
          @onRegionSelected="onRegionSelected"
          @onRegionRemove="onRegionRemove"
        />
      </div>
    </div>
    <ValidationObserver ref="contactRef" novalidate>
      <div class="my-4" v-if="showWorkshopDetailSection">
        <icon-view
          class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
          icon="fas fa-phone-alt color-orange mb-1"
          title="Información del Contacto"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
          :gradient="true"
        />

        <div class="row my-3">
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required' : ''"
            >
              <custom-input
                id="input-contact-manager"
                label="Organizador(a):"
                type="text"
                maxlength="200"
                v-model="item.contact.manager"
                :error="errors[0]"
                custom-error-msg="El Organizador(a) es requerido(a)."
              >
              </custom-input>
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required' : ''"
            >
              <custom-input
                id="input-contact-phone"
                label="Telefóno:"
                mask-type="Phone"
                placeholder="(___)-___-____"
                v-model="item.contact.phone"
                :error="errors[0]"
                custom-error-msg="El Telefóno es requerido."
              >
              </custom-input>
            </validation-provider>
          </div>

          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required|email' : ''"
              :custom-messages="{
                required: 'Favor de ingresar un correo electrónico.',
                email: 'Favor de entrar un correo electrónico válido.'
              }"
            >
              <custom-input
                id="input-contact-email"
                label="Correo Electrónico: "
                type="email"
                maxlength="200"
                v-model="item.contact.email"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-md-12 my-1">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required' : ''"
            >
              <custom-input
                id="input-contact-location"
                label="Ubicación:"
                type="text"
                v-model="item.contact.location"
                :error="errors[0]"
                custom-error-msg="La ubicación es requerida."
              >
              </custom-input>
            </validation-provider>
          </div>

          <div class="col-md-12 my-1">
            <validation-provider
              v-slot="{ errors }"
              :rules="showWorkshopDetailSection ? 'required' : ''"
            >
              <custom-input
                id="input-contact-map-link"
                label="Insertar URL de mapa para publicar el enlace de la dirección en línea:"
                type="text"
                v-model="item.contact.locationUrl"
                :error="errors[0]"
                custom-error-msg="La URL es requerida."
              >
              </custom-input>
            </validation-provider>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
// components
import PageHeader from "PageHeader";
import IconView from "icon-view";
import CustomInput from "CustomInput";
import ActionButton from "ActionButton";
import CustomTimePicker from "custom-time-picker";
import CustomDatePicker from "custom-date-picker";
import InformationToPublish from "./components/InformationToPublish";
import TagsSection from "./components/TagsSection";
import RegionsSection from "./components/RegionsSection";
import DocumentsSection from "./components/DocumentsSection";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";

// services
import {
  getInitFilter,
  getScheduleItem,
  save
} from "@/services/operations/public-portal-schedule-items";

// utils
import moment from "moment";
import scheduleItemTypes from "@/utils/constants/publicPortalScheduleItemTypes.js";
import { unRegisterMixin } from "@quisit/mipe-utils/mixins/storeGenerator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import objectToFormData from "object-to-formdata";

const URL_REGEX = /^(https):\/\/[^\s$.?#].[^\s]*$/;
const SCHEDULE_ITEM_EDIT_ROUTE_NAME = "operationPublicPortalEditItem";

export default {
  name: "NewItem",
  mixins: [unRegisterMixin, alertMixin],
  components: {
    PageHeader,
    IconView,
    CustomInput,
    ActionButton,
    CustomTimePicker,
    CustomDatePicker,
    ValidationProvider,
    ValidationObserver,
    InformationToPublish,
    TagsSection,
    RegionsSection,
    DocumentsSection
  },
  async mounted() {
    await this.onLoad();
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.path !== from.path) {
      next();
      await this.onLoad();
    }
  },
  data() {
    return {
      headerConfig: {
        title: "Añadir Noticia, Taller o Evento al Portal Público",
        icon: "fas fa-calculator",
        routes: [
          "Inicio",
          "Operaciones",
          "Mantenimiento del Portal Público",
          "Añadir"
        ]
      },
      urlRegexRule: URL_REGEX,
      item: {
        workshopDetail: {
          regions: [],
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
          cost: null,
          registrationText: null,
          registrationUrl: null
        },
        contact: {
          manager: null,
          phone: null,
          email: null,
          location: null,
          locationUrl: null
        },
        informationToPublish: {
          publishDate: null,
          dueDate: null,
          area: null,
          type: null,
          category: null,
          title: null,
          resumen: null,
          description: null
        },
        tags: [],
        documents: {
          mainImage: null,
          thumbnail: null
        },
        mainImageFile: null,
        thumbnailImageFile: null
      },
      options: {
        area: [],
        type: [],
        category: [],
        tag: [],
        region: []
      }
    };
  },
  computed: {
    showWorkshopDetailSection() {
      return (
        this.item.informationToPublish.type?.id === scheduleItemTypes.event ||
        this.item.informationToPublish.type?.id === scheduleItemTypes.workshop
      );
    },
    scheduleItemId() {
      return this.$route.params?.id ? Number(this.$route.params?.id) : null;
    },
    isNew() {
      return !this.scheduleItemId;
    }
  },
  methods: {
    async onLoad() {
      await this.fetchInitFilters();
      await this.fetchScheduleItem();
    },
    async fetchInitFilters() {
      let { data } = await getInitFilter();
      this.options = {
        area: data.areaOptions,
        category: data.categoryOptions,
        tag: data.tagOptions,
        region: data.regionOptions,
        type: data.typeOptions
      };
    },
    async fetchScheduleItem() {
      if (this.scheduleItemId) {
        let { data } = await getScheduleItem(this.scheduleItemId);

        this.item.informationToPublish.publishDate = data.publicationStartDate;
        this.item.informationToPublish.dueDate = data.publicationEndDate;
        this.item.informationToPublish.area = data.area;
        this.item.informationToPublish.type = data.type;
        this.item.informationToPublish.category = data.category;
        this.item.informationToPublish.title = data.title;
        this.item.informationToPublish.resumen = data.shortDescription;
        this.item.informationToPublish.description = data.description;
        this.item.tags = data.tags ?? [];
        this.item.mainImageFile = data.mainImage;
        this.item.thumbnailImageFile = data.thumbnailImage;

        if (this.showWorkshopDetailSection) {
          let regions = [];
          if (data.workshopInfo.regions?.length) {
            regions =
              data.workshopInfo.regions.map(x => ({
                ...x,
                name: x.name.split("|")[0],
                location: x.name.split("|")[1]
              })) ?? [];
          }

          this.item.workshopDetail.regions = regions;
          this.item.workshopDetail.startDate = data.workshopInfo.startDate;
          this.item.workshopDetail.startTime = this.dateToHour(
            data.workshopInfo.startDate
          );
          this.item.workshopDetail.endDate = data.workshopInfo.endDate;
          this.item.workshopDetail.endTime = this.dateToHour(
            data.workshopInfo.endDate
          );
          this.item.workshopDetail.cost = data.workshopInfo.cost;
          this.item.workshopDetail.registrationText =
            data.workshopInfo.registrationText;
          this.item.workshopDetail.registrationUrl =
            data.workshopInfo.registrationUrl;

          this.item.contact.manager = data.workshopInfo.organizer;
          this.item.contact.phone = data.workshopInfo.phone;
          this.item.contact.email = data.workshopInfo.email;
          this.item.contact.location = data.workshopInfo.locationText;
          this.item.contact.locationUrl = data.workshopInfo.locationUrl;
        }
      }
    },
    async handleSaveItem() {
      const isValid = await this.$refs.publishInformation.validate();
      const isWorkshopValid =
        !this.showWorkshopDetailSection ||
        ((await this.$refs.workshopInfoRef.validate()) &&
          (await this.$refs.contactRef.validate()));

      if (!isValid || !isWorkshopValid) {
        this.ShowToast(
          "Alerta",
          "Favor completar la información solicitada.",
          "error"
        );
        return;
      }

      const payload = {
        id: this.scheduleItemId,
        areaId: this.item.informationToPublish.area.id,
        typeId: this.item.informationToPublish.type.id,
        categoryId: this.item.informationToPublish.category.id,
        title: this.item.informationToPublish.title,
        description: this.item.informationToPublish.description,
        shortDescription: this.item.informationToPublish.resumen,
        publicationStartDate: this.item.informationToPublish.publishDate,
        publicationEndDate: this.item.informationToPublish.dueDate
      };

      if (this.showWorkshopDetailSection) {
        const regions =
          this.item.workshopDetail.regions.map(x => ({
            id: x.id,
            name: x.location
          })) ?? [];

        if (regions.length === 0) {
          this.ShowToast(
            "Alerta",
            "Favor completar la información solicitada. Seleccionar al menos una región.",
            "error"
          );
          return;
        }

        payload.workshopInfo = {
          regions: regions,
          startDate: this.dateToPayload(
            this.item.workshopDetail.startDate,
            this.item.workshopDetail.startTime
          ),
          endDate: this.dateToPayload(
            this.item.workshopDetail.endDate,
            this.item.workshopDetail.endTime
          ),
          registrationText: this.item.workshopDetail.registrationText,
          registrationUrl: this.item.workshopDetail.registrationUrl,
          locationText: this.item.contact.location,
          locationUrl: this.item.contact.locationUrl,
          cost: this.item.workshopDetail.cost,
          organizer: this.item.contact.manager,
          phone: this.item.contact.phone,
          email: this.item.contact.email
        };
      }

      const tags = this.item.tags.map(x => x.id) ?? [];

      if (tags?.length > 0) {
        payload.tags = tags;
      }

      let params = objectToFormData(payload, { indices: true });

      params.append("mainImage", this.item.documents.mainImage);
      params.append("thumbnailImage", this.item.documents.thumbnail);

      const { data: id } = await save(params).catch(err => {
        this.ShowToast(
          "Alerta",
          err.message || err.response.data.message || "error",
          "error"
        );
        return { id: 0 };
      });

      if (id > 0) {
        this.ShowToast(
          "Proceso exitoso",
          "Se ha publicado la información exitosamente.",
          "success"
        );

        this.loadScheduleItem(id);
        await this.onLoad();
      }
    },
    async loadScheduleItem(id) {
      if (this.isNew) {
        this.$router.push({
          name: SCHEDULE_ITEM_EDIT_ROUTE_NAME,
          params: { id: id }
        });
      }
    },
    onRegionSelected(item) {
      if (!this.item.workshopDetail.regions.some(x => x.id === item.id)) {
        this.item.workshopDetail.regions.push(item);
      }
    },
    onRegionRemove(id) {
      if (this.item.workshopDetail.regions.some(x => x.id === id)) {
        this.item.workshopDetail.regions = this.item.workshopDetail.regions.filter(
          x => x.id != id
        );
      }
    },
    dateToPayload(day, hour) {
      const _day = moment(day).format("YYYY-MM-DD");
      return moment(`${_day}/${hour}`, "YYYY-MM-DD/HH:mm").toDate();
    },
    dateToHour(datetime) {
      return datetime ? moment(datetime).format("HH:mm") : null;
    }
  }
};
</script>
